import React from "react"
import Markdown from "./markdown"
import validateClass from "../helpers/validate-class"

class Content extends React.Component {
  render() {
    const classes = this.props.classes || []

    const knownClasses = [
      "has-text-weight-light",
      "mb-0",
      "is-size-6",
      "has-text-weight-semibold",
      "p-5",
    ]

    validateClass(knownClasses, classes)

    return (
      <div className={`content ${classes.join(" ")}`}>
        <Markdown input={this.props.body} />
      </div>
    )
  }
}

export default Content
